export default __webpack_public_path__ + "static/media/reasons-to-study-at-lsc-malta.60acecc8.jpg";